/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Upoznaj nove ljude, ćaskaj, druži se",
      "Broj telefona neispravan",
      "Get the app",
      "Nastavi koristeći Apple",
      "Nastavi koristeći Facebook",
      "Nastavi koristeći Google",
      "Prijavi se",
      "Registruj se",
      "Da nastaviš, unesi karaktere koje vidiš u polje za unos.",
      "Nastavi",
      "Unesi karaktere",
      "Bezbednosna provera",
      "Ponovo učitaj",
      "Kreiraj novu lozinku koju ćeš lako pamtiti:",
      "Ažuriraj",
      "Potvrdi lozinku",
      "Lozinka mora imati barem {{num}} [[characters:num@3]].",
      "Lozinka",
      "Kreiraj novu lozinku",
      "Badoo - Blog",
      "Zaposlenje",
      "Ćaskanje",
      "Gradovi",
      "Upravljaj kolačićima",
      "Copyright © 2006 – danas. Bumble. Sva prava zadržana.",
      "Apple i Apple logotip su žigovi kompanije Apple Inc.{{__EOL__}}Google Play je žig kompanije Google LLC.",
      "Preuzmi",
      "Facebook",
      "Prati nas",
      "Centar za pomoć",
      "Instagram",
      "Jezik",
      "LinkedIn",
      "Pregled",
      "Badoo je deo Bumble Inc.",
      "Politika privatnosti",
      "Safety Centre",
      "Mapa sajta",
      "Izjava o modernom ropstvu",
      "Pravila i uslovi korišćenja",
      "Twitter",
      "Unesi svoju imejl-adresu ili broj mobilnog telefona i poslaćemo ti uputstva za kreiranje nove lozinke.",
      "Zatraži novu lozinku",
      "Unesi svoj imejl ili broj mobilnog",
      "Zaboravljena lozinka",
      "Prikazani modeli služe samo u svrhu ilustracije.",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Ne moraš da čekaš da ti uzvrate simpatije.{{__EOL__}}{{__EOL__}}Zagrebi ispod površine i pređi direktno na zanimljivije teme - kada upoznavanje zaista započinje.",
      "Želiš odmah da ćaskaš?",
      "Pristupanjem prihvataš naša <a class=\"link\" href=\"{{terms_url}}\">Pravila i uslove korišćenja</a>. Saznaj kako koristimo tvoje podatke u našoj <a class=\"link\" href=\"{{privacy_url}}\">Politici privatnosti</a>.",
      "Sa nama su upoznavanja spontana, prirodna, prijatna, <br />jer ti pomažemo da pokažeš svoju autentičnost.",
      "Za upoznavanje sa samopouzdanjem.",
      "ili",
      "Već imaš nalog?",
      "Registruj se putem imejla ili broja telefona",
      "Ti znaš šta tražiš.{{__EOL__}}Tvoja stvar, nema potrebe da se pravdaš.",
      "Želiš samo da ćaskaš? Nema problema.{{__EOL__}}Tražiš nešto ozbiljnije? Odlično.{{__EOL__}}{{__EOL__}}Ne znaš šta hoćeš? Može i to, predomišljaj se koliko hoćeš.",
      "Želim upoznavanje",
      "Ozbiljna veza",
      "Ćaskanje",
      "Upoznaj ljude koji žele isto što i ti.",
      "{{name}}, {{age}}",
      "Tvoja bezbednost je naš prioritet.",
      "Naš Safety Centre objedinjuje sve informacije i podršku koji su ti potrebni za samouvereno upoznavanje.",
      "Poseti naš Safety Centre",
      "Bezbednost na prvom mestu,<br/>uvek i svuda.",
      "Od prvog trenutka smo znali da smo jedno za drugo...",
      "Isprva me nije zanimalo ništa ozbiljno…",
      "Svakome na Badoo aplikaciji savetujem samo da bude ono što jeste...",
      "Uspešne Badoo priče",
      "Vidi još uspešnih priča",
      "__CUT__Rejting: {{num}}",
      "Apple App Store",
      "Veruj nam. Spojili smo i spajamo milione (i milione i milione) ljudi još od 2006.",
      "{{num}}+ mil.__CUT__preuzimanja",
      "{{num}}+ mil.",
      "Google Play prodavnica",
      "Znamo šta radimo.",
      "Prijavi se putem imejla ili broja telefona",
      "Unesi svoju lozinku",
      "Ne sećaš se lozinke?",
      "Registruj se",
      "Nemaš nalog?",
      "Prijavi se",
      "Registruj se"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera"
            ],
            "plural": [
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera",
                  "karaktera"
            ],
            "singular": [
                  "karakter",
                  "karaktera",
                  "karakteru",
                  "karakter",
                  "karakteru",
                  "karakterom",
                  "karakteru"
            ]
      },
      "day": {
            "few": [
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana"
            ],
            "plural": [
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana"
            ],
            "singular": [
                  "dan",
                  "dana",
                  "danu",
                  "dan",
                  "danu",
                  "danom",
                  "danu"
            ]
      },
      "hour": {
            "few": [
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata"
            ],
            "plural": [
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati"
            ],
            "singular": [
                  "sat",
                  "sata",
                  "satu",
                  "sat",
                  "satu",
                  "satom",
                  "satu"
            ]
      },
      "minute": {
            "few": [
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta"
            ],
            "plural": [
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta"
            ],
            "singular": [
                  "minut",
                  "minuta",
                  "minutu",
                  "minut",
                  "minutu",
                  "minutom",
                  "minutu"
            ]
      },
      "month": {
            "few": [
                  "meseca",
                  "meseca",
                  "meseca",
                  "meseca",
                  "meseca",
                  "meseca",
                  "meseca"
            ],
            "plural": [
                  "meseci",
                  "meseci",
                  "meseci",
                  "meseci",
                  "meseci",
                  "meseci",
                  "meseci"
            ],
            "singular": [
                  "mesec",
                  "meseca",
                  "mesecu",
                  "mesec",
                  "mesecu",
                  "mesecom",
                  "meseče"
            ]
      },
      "second": {
            "few": [
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde"
            ],
            "plural": [
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi"
            ],
            "singular": [
                  "sekunda",
                  "sekunde",
                  "sekundi",
                  "sekundu",
                  "sekundi",
                  "sekundom",
                  "sekundo"
            ]
      },
      "year": {
            "few": [
                  "godine",
                  "godine",
                  "godine",
                  "godine",
                  "godine",
                  "godine",
                  "godine"
            ],
            "plural": [
                  "godina",
                  "godina",
                  "godina",
                  "godina",
                  "godina",
                  "godina",
                  "godina"
            ],
            "singular": [
                  "godina",
                  "godine",
                  "godini",
                  "godinu",
                  "godini",
                  "godinom",
                  "godino"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
